var map = {
	".": [
		6868,
		9
	],
	"./": [
		6868,
		9
	],
	"./BackyardAdventuresCardLegalWording": [
		85515,
		9,
		666,
		515
	],
	"./BackyardAdventuresCardLegalWording.jsx": [
		85515,
		9,
		666,
		515
	],
	"./BackyardAdventuresLeaderboardLegalWording": [
		88322,
		9,
		322
	],
	"./BackyardAdventuresLeaderboardLegalWording.jsx": [
		88322,
		9,
		322
	],
	"./BackyardAdventuresLegalWording.scss": [
		65830,
		7,
		830
	],
	"./DynamicLegalWording": [
		18670,
		9
	],
	"./DynamicLegalWording.jsx": [
		18670,
		9
	],
	"./GoldenSummerLegalWording": [
		51707,
		9
	],
	"./GoldenSummerLegalWording.jsx": [
		51707,
		9
	],
	"./GoldenSummerLegalWording.scss": [
		56960,
		7
	],
	"./GrandSlamLegalWording": [
		86866,
		9
	],
	"./GrandSlamLegalWording.jsx": [
		86866,
		9
	],
	"./GrandSlamLegalWording.scss": [
		37677,
		7
	],
	"./LeafPartyLegalWording": [
		83032,
		9
	],
	"./LeafPartyLegalWording.jsx": [
		83032,
		9
	],
	"./LeafPartyLegalWording.scss": [
		94058,
		7
	],
	"./NextLevelCardLegalWording": [
		39932,
		9,
		932
	],
	"./NextLevelCardLegalWording.jsx": [
		39932,
		9,
		932
	],
	"./NextLevelLeaderboardLegalWording": [
		63055,
		9
	],
	"./NextLevelLeaderboardLegalWording.jsx": [
		63055,
		9
	],
	"./NextLevelLegalWording.scss": [
		82427,
		7
	],
	"./PoolPartyLegalWording": [
		43763,
		9
	],
	"./PoolPartyLegalWording.jsx": [
		43763,
		9
	],
	"./PoolPartyLegalWording.scss": [
		75348,
		7,
		348
	],
	"./PuppyAndKittyBowlLegalWording": [
		36722,
		9
	],
	"./PuppyAndKittyBowlLegalWording.jsx": [
		36722,
		9
	],
	"./PuppyAndKittyBowlLegalWording.scss": [
		29056,
		7
	],
	"./SpringBalloonCardLegalWording": [
		22531,
		9,
		666,
		531
	],
	"./SpringBalloonCardLegalWording.jsx": [
		22531,
		9,
		666,
		531
	],
	"./SpringBalloonLeaderboardLegalWording": [
		3302,
		9,
		666,
		302
	],
	"./SpringBalloonLeaderboardLegalWording.jsx": [
		3302,
		9,
		666,
		302
	],
	"./SpringBalloonLegalWording.scss": [
		34014,
		7,
		14
	],
	"./TreasureIslandCardLegalWording": [
		94617,
		9,
		617
	],
	"./TreasureIslandCardLegalWording.jsx": [
		94617,
		9,
		617
	],
	"./TreasureIslandLeaderboardLegalWording": [
		65117,
		9,
		117
	],
	"./TreasureIslandLeaderboardLegalWording.jsx": [
		65117,
		9,
		117
	],
	"./TreasureIslandLegalWording.scss": [
		89576,
		7,
		576
	],
	"./index": [
		6868,
		9
	],
	"./index.js": [
		6868,
		9
	],
	"components/games/elements/LegalWording": [
		6868,
		9
	],
	"components/games/elements/LegalWording/": [
		6868,
		9
	],
	"components/games/elements/LegalWording/BackyardAdventuresCardLegalWording": [
		85515,
		9,
		666,
		515
	],
	"components/games/elements/LegalWording/BackyardAdventuresCardLegalWording.jsx": [
		85515,
		9,
		666,
		515
	],
	"components/games/elements/LegalWording/BackyardAdventuresLeaderboardLegalWording": [
		88322,
		9,
		322
	],
	"components/games/elements/LegalWording/BackyardAdventuresLeaderboardLegalWording.jsx": [
		88322,
		9,
		322
	],
	"components/games/elements/LegalWording/BackyardAdventuresLegalWording.scss": [
		65830,
		7,
		830
	],
	"components/games/elements/LegalWording/DynamicLegalWording": [
		18670,
		9
	],
	"components/games/elements/LegalWording/DynamicLegalWording.jsx": [
		18670,
		9
	],
	"components/games/elements/LegalWording/GoldenSummerLegalWording": [
		51707,
		9
	],
	"components/games/elements/LegalWording/GoldenSummerLegalWording.jsx": [
		51707,
		9
	],
	"components/games/elements/LegalWording/GoldenSummerLegalWording.scss": [
		56960,
		7
	],
	"components/games/elements/LegalWording/GrandSlamLegalWording": [
		86866,
		9
	],
	"components/games/elements/LegalWording/GrandSlamLegalWording.jsx": [
		86866,
		9
	],
	"components/games/elements/LegalWording/GrandSlamLegalWording.scss": [
		37677,
		7
	],
	"components/games/elements/LegalWording/LeafPartyLegalWording": [
		83032,
		9
	],
	"components/games/elements/LegalWording/LeafPartyLegalWording.jsx": [
		83032,
		9
	],
	"components/games/elements/LegalWording/LeafPartyLegalWording.scss": [
		94058,
		7
	],
	"components/games/elements/LegalWording/NextLevelCardLegalWording": [
		39932,
		9,
		932
	],
	"components/games/elements/LegalWording/NextLevelCardLegalWording.jsx": [
		39932,
		9,
		932
	],
	"components/games/elements/LegalWording/NextLevelLeaderboardLegalWording": [
		63055,
		9
	],
	"components/games/elements/LegalWording/NextLevelLeaderboardLegalWording.jsx": [
		63055,
		9
	],
	"components/games/elements/LegalWording/NextLevelLegalWording.scss": [
		82427,
		7
	],
	"components/games/elements/LegalWording/PoolPartyLegalWording": [
		43763,
		9
	],
	"components/games/elements/LegalWording/PoolPartyLegalWording.jsx": [
		43763,
		9
	],
	"components/games/elements/LegalWording/PoolPartyLegalWording.scss": [
		75348,
		7,
		348
	],
	"components/games/elements/LegalWording/PuppyAndKittyBowlLegalWording": [
		36722,
		9
	],
	"components/games/elements/LegalWording/PuppyAndKittyBowlLegalWording.jsx": [
		36722,
		9
	],
	"components/games/elements/LegalWording/PuppyAndKittyBowlLegalWording.scss": [
		29056,
		7
	],
	"components/games/elements/LegalWording/SpringBalloonCardLegalWording": [
		22531,
		9,
		666,
		531
	],
	"components/games/elements/LegalWording/SpringBalloonCardLegalWording.jsx": [
		22531,
		9,
		666,
		531
	],
	"components/games/elements/LegalWording/SpringBalloonLeaderboardLegalWording": [
		3302,
		9,
		666,
		302
	],
	"components/games/elements/LegalWording/SpringBalloonLeaderboardLegalWording.jsx": [
		3302,
		9,
		666,
		302
	],
	"components/games/elements/LegalWording/SpringBalloonLegalWording.scss": [
		34014,
		7,
		14
	],
	"components/games/elements/LegalWording/TreasureIslandCardLegalWording": [
		94617,
		9,
		617
	],
	"components/games/elements/LegalWording/TreasureIslandCardLegalWording.jsx": [
		94617,
		9,
		617
	],
	"components/games/elements/LegalWording/TreasureIslandLeaderboardLegalWording": [
		65117,
		9,
		117
	],
	"components/games/elements/LegalWording/TreasureIslandLeaderboardLegalWording.jsx": [
		65117,
		9,
		117
	],
	"components/games/elements/LegalWording/TreasureIslandLegalWording.scss": [
		89576,
		7,
		576
	],
	"components/games/elements/LegalWording/index": [
		6868,
		9
	],
	"components/games/elements/LegalWording/index.js": [
		6868,
		9
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 94722;
module.exports = webpackAsyncContext;